// --- cantSwiper.js ---

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import gsap from 'gsap';

export function initCantineSwiper() {
  const swiperContainer = document.querySelector('.cantine-swiper');
  if (!swiperContainer) {
    return;
  }

  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  
  // Funzione per forzare il re-rendering degli SVG in Safari
  const forceSvgRendering = () => {
    if (isSafari) {
      const svgs = swiperContainer.querySelectorAll('.swiper-button-next svg, .swiper-button-prev svg');
      svgs.forEach(svg => {
        // Forza il re-rendering dell'SVG
        svg.style.display = 'none';
        svg.offsetHeight; // Trigger reflow
        svg.style.display = 'block';
        
        // Aggiungi proprietà CSS per Safari
        svg.style.webkitTransform = 'translateZ(0)';
        svg.style.transform = 'translateZ(0)';
        svg.style.webkitBackfaceVisibility = 'hidden';
        svg.style.backfaceVisibility = 'hidden';
      });
    }
  };
  
  // Configurazione base del Swiper
  const swiperConfig = {
    modules: [Navigation, Pagination],
    slidesPerView: 4,
    spaceBetween: 30,
    // Abilita drag/swipe
    allowTouchMove: true,
    simulateTouch: true,
    touchRatio: 1,
    touchAngle: 45,
    grabCursor: false,
    navigation: {
      nextEl: '.cantine-swiper .swiper-button-next',
      prevEl: '.cantine-swiper .swiper-button-prev',
    },
    pagination: {
      el: '.cantine-swiper .swiper-pagination',
      type: 'progressbar',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1624: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  };

  // Fix specifico per Chrome: aggiungi gestori di eventi per debugging e configurazioni speciali
  if (isChrome) {
    // Configurazioni specifiche per Chrome
    swiperConfig.touchStartPreventDefault = false;
    swiperConfig.preventClicksPropagation = false;
    swiperConfig.preventClicks = false;
    swiperConfig.allowTouchMove = true;
    
    swiperConfig.on = {
      init: function() {
        //console.log('🔍 Chrome: Swiper cantine inizializzato');
        
        // Aggiungi un marker specifico per Chrome per identificare meglio i link
        const slides = this.slides;
        slides.forEach((slide, index) => {
          slide.setAttribute('data-chrome-swiper-slide', index);
          const links = slide.querySelectorAll('a[href*="/cantine/"], a[href*="/wineries/"]');
          links.forEach(link => {
            link.setAttribute('data-chrome-cantina-link', 'true');
          });
        });
      },
      // slideChange: function() {
      //   console.log('🔍 Chrome: Slide cambiata', this.activeIndex);
      // },
      // touchStart: function(swiper, event) {
      //   console.log('🔍 Chrome: Touch start su Swiper');
      // },
      // click: function(swiper, event) {
      //   console.log('🔍 Chrome: Click su Swiper', event.target);
      //   // Non preveniamo il comportamento di default per i link
      //   if (event.target.closest('a[href]')) {
      //     console.log('🔍 Chrome: Click su link dentro Swiper - permettendo navigazione');
      //   }
      // }
    };
  }

  // Fix specifico per Safari: aggiungi gestori di eventi per il rendering degli SVG
  if (isSafari) {
    swiperConfig.on = {
      init: function() {
        console.log('🍎 Safari: Swiper cantine inizializzato');
        // Forza il rendering degli SVG dopo l'inizializzazione
        setTimeout(forceSvgRendering, 100);
      },
      slideChange: function() {
        // Forza il rendering degli SVG dopo ogni cambio slide
        setTimeout(forceSvgRendering, 50);
      }
    };
  }

  const swiperInstance = new Swiper('.cantine-swiper', swiperConfig);
  
  // Effetto scale durante il grab (simile a gallerySwiper)
  const slideImages = () => swiperContainer.querySelectorAll('.swiper-slide img');
  const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
  
  if (swiperWrapper) {
    swiperWrapper.addEventListener('pointerdown', () => {
      const images = slideImages();
      if (images.length > 0 && gsap) {
        gsap.to(images, {
          duration: 0.5,
          scale: 0.95
        });
      }
    });

    const resetScale = () => {
      const images = slideImages();
      if (images.length > 0 && gsap) {
        gsap.to(images, {
          duration: 0.7,
          scale: 1
        });
      }
    };

    swiperWrapper.addEventListener('pointerup', resetScale);
    swiperWrapper.addEventListener('pointerleave', resetScale);
  }

  // Ripristina la scala al termine delle transizioni di Swiper
  if (swiperInstance && swiperInstance.on) {
    swiperInstance.on('transitionEnd', () => {
      const images = slideImages();
      if (images.length > 0 && gsap) {
        gsap.to(images, {
          duration: 0.7,
          scale: 1
        });
      }
    });
  }
  
  // Fix immediato per Safari - forza il rendering degli SVG al caricamento
  if (isSafari) {
    // Esegui il fix immediatamente e dopo un delay
    forceSvgRendering();
    setTimeout(forceSvgRendering, 500);
    setTimeout(forceSvgRendering, 1000);
  }
  
  // Previeni il drag delle immagini per permettere lo swipe
  const images = swiperContainer.querySelectorAll('img');
  images.forEach(img => {
    img.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });
    // Aggiungi anche pointer-events via style per sicurezza
    img.style.pointerEvents = 'none';
    img.style.userSelect = 'none';
  });
  
  // Previeni anche la selezione del testo durante il drag
  const slides = swiperContainer.querySelectorAll('.swiper-slide');
  slides.forEach(slide => {
    slide.style.userSelect = 'none';
  });
  
  // Per Chrome, aggiungi un listener aggiuntivo sui link delle cantine nel Swiper
  if (isChrome) {
    setTimeout(() => {
      const cantinaLinks = swiperContainer.querySelectorAll('a[href*="/cantine/"], a[href*="/wineries/"]');
      cantinaLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          console.log('🔍 Chrome: Click su link cantina in Swiper', {
            href: this.href,
            slide: this.closest('.swiper-slide'),
            slideIndex: this.closest('.swiper-slide')?.getAttribute('data-chrome-swiper-slide')
          });
        }, { capture: true });
      });
    }, 100);
  }
  
  return swiperInstance;
}